import React from 'react';
import { Input } from '@/components/ui/input';
import { fmtRM } from './payslipEditUtils';

export function StatutoryOverrideRow({ field, autoValue, override, onToggle, onChange }) {
  const enabled = !!override?.enabled;
  return (
    <div className="grid grid-cols-12 items-center gap-2 py-1.5" data-testid={`stat-row-${field.key}`}>
      <span className="col-span-5 text-sm text-slate-700 dark:text-slate-300">{field.label}</span>
      <span className="col-span-3 text-xs text-slate-500 dark:text-slate-400 tabular-nums">
        Auto: {autoValue == null ? '…' : fmtRM(autoValue)}
      </span>
      <label className="col-span-1 flex items-center justify-center cursor-pointer" title="Manual override">
        <input
          type="checkbox"
          checked={enabled}
          onChange={(e) => onToggle(field.key, e.target.checked)}
          data-testid={`stat-override-toggle-${field.key}`}
          className="h-4 w-4 accent-amber-600"
        />
      </label>
      <div className="col-span-3">
        <Input
          type="number"
          step="0.01"
          min="0"
          disabled={!enabled}
          value={enabled ? override.value : ''}
          placeholder={enabled ? '0.00' : 'auto'}
          onChange={(e) => onChange(field.key, e.target.value)}
          data-testid={`stat-override-input-${field.key}`}
          className={`h-8 text-right text-sm ${enabled ? 'border-amber-400 bg-amber-50 dark:bg-amber-900/20' : ''}`}
        />
      </div>
    </div>
  );
}
